// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SubscriptionContentRenewButton_button_3cM-n{border:1px solid var(--supster-secondary)!important}", ""]);
// Exports
exports.locals = {
	"button": "SubscriptionContentRenewButton_button_3cM-n"
};
module.exports = exports;
